var map = {
	"./blue_dragon.png": 129,
	"./bord_bia.png": 130,
	"./canon.png": 131,
	"./cft.png": 132,
	"./gll.png": 133,
	"./imex.png": 134,
	"./london_sport.png": 135,
	"./pataks.png": 136,
	"./sony.png": 137,
	"./tabasco.png": 138,
	"./tesco.png": 139,
	"./walkabout.png": 140
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 128;